import { useEffect, useMemo, useState } from "react";
import { getAdminUser } from "../api/adminClient";
import { useNexusOptional } from "../ai/NexusProvider";
import { buildWorkspaceProductDoc, subscribeServerWorkspaceIdentity } from "../ai/workspaceContext";

/** Workspace snapshot for product flags (LITE on/off) — updates after GET /workspace. */
export function useWorkspaceProductDoc() {
  const nexus = useNexusOptional();
  const [identityTick, setIdentityTick] = useState(0);

  useEffect(() => subscribeServerWorkspaceIdentity(() => setIdentityTick((n) => n + 1)), []);

  const user = getAdminUser();
  return useMemo(
    () => buildWorkspaceProductDoc(user),
    [
      user?.tenant_id,
      user?.email_pack,
      user?.lite_invite_available,
      nexus?.workspaceBrandingRevision,
      identityTick,
    ]
  );
}
